<template>
  <footer class="footer">
    <div class="footer-container">
      <!-- Appel à l'action -->
      <div class="footer-cta">
        <div>
          <h3 class="footer-cta-title">Un projet, une alternance, une question ?</h3>
          <p class="footer-cta-text">Je réponds rapidement, n'hésitez pas à m'écrire.</p>
        </div>
        <a class="btn-gradient" @click="navigateToTop('/contact')">
          <i class="bi bi-send"></i> Me contacter
        </a>
      </div>

      <div class="footer-main">
        <!-- Logo et description -->
        <div class="footer-brand">
          <span class="brand-name">Alexis<span class="brand-dot">.</span>dev</span>
          <p class="footer-description">Apprenti développeur passionné par l'informatique et les nouvelles technologies.</p>
          <a href="mailto:dupainalexis@gmail.com" class="footer-mail">
            <i class="bi bi-envelope"></i> dupainalexis@gmail.com
          </a>
        </div>

        <!-- Navigation rapide -->
        <div class="footer-section">
          <h6 class="footer-heading">Navigation</h6>
          <ul class="footer-links">
            <li><a @click="scrollToSection('apropos')" class="footer-link">À propos</a></li>
            <li><a @click="scrollToSection('formations')" class="footer-link">Parcours</a></li>
            <li><a @click="navigateToTop('/projets')" class="footer-link">Projets</a></li>
            <li><a @click="navigateToTop('/competences')" class="footer-link">Compétences</a></li>
          </ul>
        </div>

        <!-- Informations légales -->
        <div class="footer-section">
          <h6 class="footer-heading">Informations</h6>
          <ul class="footer-links">
            <li><a @click="navigateToTop('/mentions-legales')" class="footer-link">Mentions légales</a></li>
            <li><a @click="navigateToTop('/conditions-utilisation')" class="footer-link">Conditions d'utilisation</a></li>
          </ul>
        </div>

        <!-- Réseaux sociaux -->
        <div class="footer-section">
          <h6 class="footer-heading">Réseaux</h6>
          <div class="footer-social">
            <a href="https://github.com/adupain" target="_blank" rel="noopener" class="social-btn" title="GitHub" aria-label="GitHub">
              <i class="bi bi-github"></i>
            </a>
            <a href="https://www.instagram.com/al.dup40" target="_blank" rel="noopener" class="social-btn" title="Instagram" aria-label="Instagram">
              <i class="bi bi-instagram"></i>
            </a>
          </div>
        </div>
      </div>

      <!-- Copyright -->
      <div class="footer-bottom">
        <p>© {{ currentYear }} Alexis Dupain. Tous droits réservés.</p>
        <p>Fait avec <i class="bi bi-heart-fill"></i> Vue.js &amp; Supabase</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  },
  methods: {
    scrollToSection(sectionId) {
      // Vérifier que la section existe (seulement apropos et formations maintenant)
      const validSections = ['apropos', 'formations']
      if (!validSections.includes(sectionId)) {
        return
      }
      
      // Si on est déjà sur la page d'accueil, faire défiler directement
      if (this.$route.path === '/') {
        this.smoothScrollTo(sectionId)
      } else {
        // Sinon, naviguer vers l'accueil puis faire défiler
        this.$router.push('/').then(() => {
          // Attendre que la route soit chargée
          this.$nextTick(() => {
            setTimeout(() => {
              this.smoothScrollTo(sectionId)
            }, 100)
          })
        })
      }
    },
    
    smoothScrollTo(sectionId) {
      const element = document.getElementById(sectionId)
      if (element) {
        // Calculer la position en tenant compte de la navbar fixe
        const navbarHeight = 88 // Hauteur approximative de la navbar
        const elementPosition = element.offsetTop - navbarHeight
        
        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth'
        })
      }
    },
    
    navigateToTop(route) {
      // Naviguer vers la route et s'assurer que la page défile en haut (simple et fluide)
      this.$router.push(route).then(() => {
        this.$nextTick(() => {
          // Une seule tentative fluide après le rendu complet
          setTimeout(() => {
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            })
          }, 100)
        })
      }).catch(error => {
        console.error('Erreur de navigation:', error)
      })
    }
  }
}
</script>